import { render, staticRenderFns } from "./fiestasneg.vue?vue&type=template&id=da529470&"
import script from "./fiestasneg.vue?vue&type=script&lang=js&"
export * from "./fiestasneg.vue?vue&type=script&lang=js&"
import style0 from "./fiestasneg.vue?vue&type=style&index=0&id=da529470&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports